import { render, staticRenderFns } from "./VariantsConstructor.vue?vue&type=template&id=124a57a8"
import script from "./VariantsConstructor.vue?vue&type=script&lang=js"
export * from "./VariantsConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124a57a8')) {
      api.createRecord('124a57a8', component.options)
    } else {
      api.reload('124a57a8', component.options)
    }
    module.hot.accept("./VariantsConstructor.vue?vue&type=template&id=124a57a8", function () {
      api.rerender('124a57a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/variants-constructor/VariantsConstructor.vue"
export default component.exports